import React, {useState} from "react";
import {useNavigate} from "react-router";
import {AppBar, Button, IconButton, ListItemIcon, Menu, MenuItem, useTheme} from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {AccountCircle, Logout, Settings} from "@mui/icons-material";
import {getUserName, logout} from "../utils";

export const AppHeader = ({handleNavigateToHome, handleNavigateToSettings}) => {
    const theme = useTheme();
    const dims = theme.dimensions;
    const navigate = useNavigate();
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const [profileMenuAnchorEl, setProfileMenuAnchorEl] = useState(null);

    const handleOpenProfileMenu = (event) => {
        setProfileMenuAnchorEl(event.target);
        setProfileMenuOpen(true);
    };

    const handleCloseProfileMenu = () => {
        setProfileMenuOpen(false);
    };

    const handleSettingsClick = () => {
        setProfileMenuOpen(false);
        handleNavigateToSettings();
    };

    const handleLogOut = () => {
        setProfileMenuOpen(false);
        logout();
        navigate('/');
    };

    return (
        <div style={{width: '100%'}}>
            <AppBar style={{height: dims.headerHeight}}>
                <Grid container>
                    <Grid size={2}>
                        <Button style={{marginTop: 2, marginLeft: 12}} onClick={handleNavigateToHome}>
                            <Typography variant="h4" color="secondary">FFED</Typography>
                        </Button>
                    </Grid>
                    <Grid size={8}>
                    </Grid>
                    <Grid size={2}>
                        <div style={{marginTop: 10, textAlign: "right"}}>
                            <Typography variant="subtitle1" color="inherit" display="inline">{getUserName()}</Typography>
                            <IconButton style={{color: "white", marginRight: 15}} onClick={handleOpenProfileMenu}>
                                <AccountCircle/>
                            </IconButton>
                            <Menu id="profile-menu" anchorEl={profileMenuAnchorEl} open={profileMenuOpen} onClose={handleCloseProfileMenu}>
                                <MenuItem onClick={handleSettingsClick}>
                                    <ListItemIcon>
                                        <Settings/>
                                    </ListItemIcon>
                                    Settings
                                </MenuItem>
                                <MenuItem onClick={handleLogOut}>
                                    <ListItemIcon>
                                        <Logout/>
                                    </ListItemIcon>
                                    Log out
                                </MenuItem>
                            </Menu>
                        </div>
                    </Grid>
                </Grid>
            </AppBar>
            <div style={{height: dims.headerHeight}}/>
        </div>
    );
};